import Typography from "typography";

/*
 * Const typography = new Typography({
 * 	baseFontSize: "18px",
 * 	baseLineHeight: 1.45,
 * 	headerFontFamily: [
 * 		"Avenir Next",
 * 		"Helvetica Neue",
 * 		"Segoe UI",
 * 		"Helvetica",
 * 		"Arial",
 * 		"sans-serif"
 * 	],
 * 	bodyFontFamily: [
 * "Georgia",
 * "serif"
 * ]
 * });
 */

// Import theme from "typography-theme-moraga";
import theme from "typography-theme-noriega";

/*
 * Import theme from "typography";
 * theme.baseFontSize = "16px";
 */
theme.baseFontSize = "17px";

/*
 * Theme.baseFontSize = '22px'
 * theme.headerWeight = 400;
 * theme.headerWeight = 200;
 */
const typography = new Typography(theme);

export default typography;



// WEBPACK FOOTER //
// ./src/utils/typography.js